module.exports = __webpack_public_path__ + "static/media/05.7fcce23a.png";